import swal from 'sweetalert'

export const utilMixin = {
    methods: {
        /**
         * Promise-based confirm dialog wrapping SweetAlert.
         * Resolves to true when the user confirms, false on cancel/dismiss.
         *
         *   const ok = await this.$confirm({ title: 'Delete?', text: '...', dangerMode: true })
         *   if (!ok) return
         */
        $confirm(opts = {}) {
            const {
                title       = 'Are you sure?',
                text        = '',
                icon        = 'warning',
                confirmText = 'Yes',
                cancelText  = 'Cancel',
                dangerMode  = false,
            } = typeof opts === 'string' ? { text: opts } : opts

            return swal({
                title,
                text,
                icon,
                dangerMode,
                buttons: {
                    cancel:  { text: cancelText, value: false, visible: true },
                    confirm: { text: confirmText, value: true },
                },
            }).then(v => !!v)
        },

        $snakeToTitleCase(s) {
            return s.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase())
        },

        $camelToTitleCase(s) {
            const result = s.replace(/([A-Z])/g, ' $1');
            return result.charAt(0).toUpperCase() + result.slice(1);
        },

        $localeDate(date) {
            if(!date) return null
            return new Date(date).toLocaleDateString('en-GB')
        },

        $localeDateTime(datetime) {
            if(!datetime) return null
            return (new Date(datetime)).toLocaleDateString('en-GB', {hour: '2-digit', minute: '2-digit'})
            // return new Date(datetime).toLocaleString('en-GB')
            // let d = new Date(datetime)
            // return [d.getDate(), d.getMonth()+1, d.getFullYear()].join('/') + ' ' + [d.getHours(), d.getMinutes()].join(':')
        },

        $formattedTime(datetime) {
            if(!datetime) return null
            return (new Date(datetime)).toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit', hour12: false});
        },

        $formattedNumber(number) {
            return new Intl.NumberFormat().format(number, {minimumFractionDigits: 2})
        },

        $formattedAmount(number) {
            return (+number).toLocaleString(undefined, {
                minimumFractionDigits: 2,
            })
        },

        $monthInString(month) {
            return new Intl.DateTimeFormat('en', { month: 'long' }).format(new Date(month)); // January
        },

        $documentStatusList() {
            return [
                {label: 'Draft', value: 'draft'},
                {label: 'Correction Required', value: 'correction_required'},
                {label: 'Complete', value: 'complete'},
            ]
        },

        $notBeforeToday(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
        },

        $notAfterToday(date) {
            return date > new Date(new Date().setHours(0, 0, 0, 0));
        },

        $dateFormatYYYY(date) {
            return new Date(date).getFullYear()
        },

        $isDev(){
            return window?.location?.port == 4000
        },

        dateFormat(date, dateFormat) {
            if(dateFormat == 'mv') {
              return (new Date(date)).toLocaleDateString('en-GB')
            }
      
            if(dateFormat == 'iso') {
               return format(date,'YYYY-MM-DD');
            }
      
            if(dateFormat == 'iso-hh-mm') {
                return format(date,'YYYY-MM-DD HH:mm');
            }
            return 'undefined format'
        },

        $getRandomHexColor() {
            let color;
            do {
                color = '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
            } while (color.toLowerCase() === '#000000' || color.toLowerCase() === '#ffffff');
            return color;
        },

        $isMobile() {
            const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
            return regex.test(navigator.userAgent);
        }
    }
}